export enum ArInvoiceType {
  RepairCustomer = 1,
  RepairOwner = 2,
  RepairRailroad = 3,
  RepairCustomerCredit = 4,
  Scrap = 5,
  StorageOwner = 6,
  StorageCustomer = 7,
  NoWork = 8,
  BaseRentalCustomer = 9,
  FreightSwitchOwner = 10,
  FreightSwitchCustomer = 11,
  CarHireMileageCustomer = 12,
  CarHireMileageRailroad = 13,
  StipLoss = 14,
  FmvDetermination = 15,
  ArExcessMileage = 16,
  TankcarEqualization = 17,
  BaseRentalOwner = 18
}
